<template>
    <div>
        <div class="results" v-if="getOffers.count > 0">
            <div class="results-item" v-for="car in getOffers.cars" :key="car.id">
                <div class="results-item-image"  v-lazy:background-image="car.photo_md">
                    <!-- <img v-bind:src="car.photo_url" v-bind:alt="car.brand_name" > -->
                </div>
                <div class="results-item-title">
                    <h3>{{car.brand_name}} {{car.model_name}}</h3>
                    <p>
                        <strong>
                            {{car.version}}
                        </strong>
                    </p>
                </div>
                <div class="results-item-params first">
                    <div>
                        <small>Rok produkcji</small>
                        <br>
                        <strong>{{car.production_year}}</strong>
                    </div>
                    <div>
                        <small>Rodzaj paliwa</small>
                        <br>
                        <strong>{{car.fuel}}</strong>
                    </div>
                </div>
                <div class="results-item-params">
                    <div>
                        <small>silnik</small>
                        <br>
                        <strong>{{capacityFormat.to(car.capacity)}} cm<sup>3</sup></strong>
                    </div>
                    <div>
                        <small>Moc maksymalna</small>
                        <br>
                        <strong>{{car.power}} KM</strong>
                    </div>
                </div>
                <div class="results-item-price " v-if="car.price_month > 0">

                    <h3 class="text-center results-item-price-leasing">
                        <img src="@/assets/leaseing.png" alt="Cena">
                        Leasing <span class="bigprice">{{priceFormat.to(car.price_month)}}</span> zł/mc*
                    </h3>
                </div>
                <div class="results-item-price " v-else>
                  <h3 class="text-center results-item-price-leasing" v-if="car.vin === 'WAUZZZ8V2KA118921'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(1798,67)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else-if="car.vin === 'WAUZZZ8V8KA114369'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(1845,54)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else-if="car.vin === 'WAUZZZF44KA118591'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(1728,79)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else-if="car.vin === 'WAUZZZF54KA027703'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(2139,59)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else-if="car.vin === 'WAUZZZF2XKN084132'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(3066,35)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else-if="car.vin === 'WAUZZZFY0K2109335'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(2019,99)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else-if="car.vin === 'WAUZZZFY1K2117458'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(1931,77)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else-if="car.vin === 'WAUZZZFY4K2115090'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(1931,77)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else-if="car.vin === 'WAUZZZFY4K2088425'">
                    <img src="@/assets/leaseing.png" alt="Cena">
                    Leasing <span class="bigprice">{{priceFormat.to(2149,37)}}</span> zł/mc*
                  </h3>
                  <h3 class="text-center results-item-price-leasing" v-else>
                    &nbsp;<br>
                    &nbsp;<br>
                  </h3>
                </div>
                <div class="results-item-price">
                    <h3 class="text-center">
                        <img src="@/assets/price.png" alt="Cena">
                        {{priceFormat.to(car.price)}}
                    </h3>
                </div>
                <div>
                    <a class="results-item-more mobile" href="#form">
                        <span v-on:click="$store.commit('setSelectedOffer','Zainteresowany ofertą: '+car.id+' '+car.brand_name+' '+car.model_name+' ')">
                            Dowiedz się więcej <img src="@/assets/read-more.png" alt=">">
                        </span >
                    </a>
                    <span class="results-item-more desktop" v-on:click="$store.commit('setSelectedOffer','Zainteresowany ofertą: '+car.id+' '+car.brand_name+' '+car.model_name+' ')">
                        Dowiedz się więcej <img src="@/assets/read-more.png" alt=">">
                    </span >
                </div>
            </div>
            <small class="results-annotation">
              *Rata miesięczna dla prezentowanego modelu Audi: dla opłaty wstępnej 10%, przebiegu 30 000 km rocznie i okresu finansowania 36 miesięcy.
            </small>
            <br>
        </div>
        <div v-else>
            <h1 class="text-center">Brak ofert o podanych kryteriach</h1>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'

import wNumb from 'wnumb'

export default {
  name: 'results',
  data() {
      return {
        priceFormat : wNumb({
            mark: ',',
            thousand: ' ',
            suffix: ' PLN'
        }),
        capacityFormat : wNumb({
            mark: ',',
            thousand: ' ',
            suffix: ' '
        })
      }
  },
  computed: {
      ...mapGetters(['getOffers'])
  }
}
</script>

<style lang="scss" scoped>
    .results{
      display:flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      &-annotation{
        font-size: 12px;
        @media(max-width: 960px){
          margin-left: 10px;
        }
      }
      &-item{
          box-shadow: 0px 0px 26px -15px rgba(0,0,0,0.75);
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          margin-right: 1rem;
          margin-bottom: 4rem;
          border-bottom: .5rem solid #bb0a30;
          width: calc(100% - 2em);
            margin-left: 1rem;
          @media(min-width: 960px){
              width: calc(100% / 2 - 2rem);
          }
          @media(min-width: 1400px){
            width: calc(100% / 3 - 1rem);
            margin-left: 0;
          }
          &-price{
            &-leasing{
              font-size: 1rem!important;
            }
          }
          &-image{
              line-height: 0;
                width:100%;
                height: calc(100vw / 6.7);
                background-size: cover;
                background-repeat: no-repeat;
                background-position:bottom center;
                @media(max-width: 960px){
                    height: calc(100vw / 1.5);
                }
          }
          &-title{
            background-color: #bb0a30;
            padding: .5rem 2rem;
            color: #FFF;
            min-height: 108px;
            h3{
                margin: 0;
            }
            p{
                font-size: .8rem;
                margin: .5rem 0;
            }
          }
          &-params{
              display:flex;
              justify-content: space-around;
              padding: .5rem 2rem 0 2rem;
              &.first{
                  margin-top: 1.5rem;
              }
              small{
                  font-size: .75rem;
              }
              strong{
                  font-size: 1.75rem;
                  font-weight: normal;
                  color: #727577;
                  line-height: 1.25;

              }
              div{
                  width: 100%;
              }
          }
          h3{
              font-size: 1.25rem;
              line-height: 1;
              margin: 1rem 0 0 0;
              img{
                  transform: translateY(25%)
              }
          }
          a{
            text-decoration: none;

          }
          &-more{
              text-align: center;
              display: block;
              text-decoration: none;
              font-weight: bold;
              color: #000;
              background-color: #f1f1f1;
              margin-top: 1rem;
              padding: 1rem .5rem;
              cursor: pointer;
          }
          sup{
              font-size: .75rem;
          }
      }
    }
    .desktop{
        display: none;
        @media(min-width: 780px){
            display: block;
        }
    }
    .mobile{
        display: block;
        @media(min-width: 780px){
            display: none;
        }
    }
    .bigprice{
      font-size: 1.45rem;
    }
</style>
